var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SubAPI } from "./SubAPI";
var ServiceRequestsAPI = /** @class */ (function (_super) {
    __extends(ServiceRequestsAPI, _super);
    function ServiceRequestsAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ServiceRequestsAPI.prototype.list = function (props) { return this.fetcher.get("/api/service-requests", props); };
    ServiceRequestsAPI.prototype.get = function (id) { return this.fetcher.get("/api/service-request", { id: id }); };
    ServiceRequestsAPI.prototype.create = function (rec) { var body = { info: JSON.stringify(rec.info) }; for (var i = 0; i < rec.files.length; i++) {
        body["file-" + i] = rec.files[i];
    } return this.fetcher.postFormData("/api/service-request/create", body); };
    ServiceRequestsAPI.prototype.update = function (rec) { return this.fetcher.post("/api/service-request/update", rec); };
    ServiceRequestsAPI.prototype.createLinkedServiceRecord = function (input) { return this.fetcher.post("/api/service-request/create-linked-service-record", input); };
    return ServiceRequestsAPI;
}(SubAPI));
export { ServiceRequestsAPI };
